import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { Uris } from '../Uris';
import { GlobalFunction } from '../globalFunction';
import {
  UsersForm,
  SubmitUserList,
  UsersListItem,
  permissions,
} from '../../interfaces/users/users.interfaces';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(
    private http: HttpClient,
    public router: Router,
    public globalFunction: GlobalFunction,
  ) {}
  permissions: permissions = {
    stores: true,
    sectors: true,
    routes: true,
    logistics: true,
    sales: true,
    users: true,
    settings: true,
    control: true,
    inventory: true,
    courier_access: true,
    suggested_calculator: true,
  };

  /* OBTENER TODOS LOS USUARIOS */
  getUsers(query: string): Observable<SubmitUserList> {
    return this.http
      .get<SubmitUserList>(`${Uris.API_USERS}${query}`, this.globalFunction.headers())
      .pipe(map((resp: SubmitUserList) => resp));
  }

  /* OBTENER TODOS LOS ADMINISTRADORES */
  getAdmins(query: string): Observable<SubmitUserList> {
    return this.http
      .get<SubmitUserList>(`${Uris.API_ADMINS}${query}`, this.globalFunction.headers())
      .pipe(map((resp: SubmitUserList) => resp));
  }

  /* OBTENER TODOS LOS REPARTIDORES */
  getCouriers(query: string): Observable<UsersListItem[] | SubmitUserList> {
    return this.http
      .get<UsersListItem[] | SubmitUserList>(
        `${Uris.API_COURIERS}${query}`,
        this.globalFunction.headers(),
      )
      .pipe(map((resp: UsersListItem[] | SubmitUserList) => resp));
  }

  /* CREAR UN NUEVO ADMINISTRADOR */
  postUser(
    query: string,
    type: 'admin' | 'courier',
    data: FormData | UsersForm,
  ): Observable<UsersForm> {
    const headers =
      data instanceof FormData
        ? this.globalFunction.headersMultipart()
        : this.globalFunction.headers();

    return this.http
      .post<UsersForm>(
        `${Uris[type === 'admin' ? 'API_ADMINS' : 'API_COURIERS']}${query}`,
        data,
        headers,
      )
      .pipe(map((resp: UsersForm) => resp));
  }

  update(
    id: number,
    type: 'admin' | 'courier',
    data: FormData | Partial<UsersForm>,
  ): Observable<UsersForm> {
    const headers =
      data instanceof FormData
        ? this.globalFunction.headersMultipart()
        : this.globalFunction.headers();

    return this.http
      .patch<UsersForm>(
        `${Uris[type === 'admin' ? 'API_ADMINS' : 'API_COURIERS']}${id}/`,
        data,
        headers,
      )
      .pipe(map((resp: UsersForm) => resp));
  }

  patch(
    id: number,
    type: 'admin' | 'courier',
    data: Record<string, unknown>,
  ): Observable<UsersForm> {
    return this.http
      .patch<UsersForm>(
        `${Uris[type === 'admin' ? 'API_ADMINS' : 'API_COURIERS']}${id}/`,
        data,
        this.globalFunction.headers(),
      )
      .pipe(map((resp: UsersForm) => resp));
  }
  activeDisabledUser(
    id: number,
    active: boolean,
    type: 'admin' | 'courier',
  ): Observable<{ detail: string }> {
    return this.http
      .post<{
        detail: string;
      }>(
        `${Uris[type === 'admin' ? 'API_ADMINS' : 'API_COURIERS']}${id}/${active ? 'enable' : 'disable'}/`,
        {},
        this.globalFunction.headers(),
      )
      .pipe(map((resp: { detail: string }) => resp));
  }

  delete(id: number, type: 'admin' | 'courier'): Observable<UsersForm> {
    return this.http
      .delete<UsersForm>(
        `${Uris[type === 'admin' ? 'API_ADMINS' : 'API_COURIERS']}${id}/`,
        this.globalFunction.headers(),
      )
      .pipe(map((resp: UsersForm) => resp));
  }
  getUserById(id: number): Observable<UsersForm> {
    return this.http
      .get<UsersForm>(`${Uris['API_USERS']}${id}/`, this.globalFunction.headers())
      .pipe(map((resp: UsersForm) => resp));
  }
  getUserPermissionsById(id: number): Observable<permissions> {
    return this.http
      .get<permissions>(`${Uris.API_ADMINS}${id}/permissions/`, this.globalFunction.headers())
      .pipe(map((resp: permissions) => resp));
  }
  updateAdminPermissionsById(id: number, data: Record<string, unknown>): Observable<permissions> {
    return this.http
      .put<permissions>(
        `${Uris.API_ADMINS}${id}/change_permissions/`,
        data,
        this.globalFunction.headers(),
      )
      .pipe(map((resp: permissions) => resp));
  }

  changePasswordById(id: number, data: Record<string, unknown>): Observable<permissions> {
    return this.http
      .put<permissions>(
        `${Uris.API_USERS}${id}/change_password/`,
        data,
        this.globalFunction.headers(),
      )
      .pipe(map((resp: permissions) => resp));
  }
  setPasswordById(id: number, data: Record<string, unknown>): Observable<permissions> {
    return this.http
      .post<permissions>(
        `${Uris.API_USERS}${id}/set_password/`,
        data,
        this.globalFunction.headers(),
      )
      .pipe(map((resp: permissions) => resp));
  }
}
